var map = {
	"./_ar.json": "0821",
	"./_en.json": "e248",
	"./ar.json": "af08",
	"./bn.json": "8782",
	"./bs.json": "5dca",
	"./en.json": "edd4",
	"./es.json": "a306",
	"./fa.json": "15ad",
	"./fr.json": "f693",
	"./ha.json": "36b7",
	"./hi.json": "7a03",
	"./id.json": "210c",
	"./ku.json": "4b66",
	"./ml.json": "b7ff",
	"./pt.json": "5d67",
	"./ru.json": "7704",
	"./si.json": "0e7c",
	"./sw.json": "0e32",
	"./te.json": "143f",
	"./tl.json": "405e",
	"./tr.json": "ffeb",
	"./ug.json": "a986",
	"./ur.json": "621c",
	"./vi.json": "aced",
	"./zh.json": "3504"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";